<mat-dialog-content>
  @if ((currentVars$ | async)?.length) {
    <mat-accordion>
      @for (group of customizationSchema; track group) {
        <mat-expansion-panel>
          @if (varMap[group.variables[0]]) {
            <mat-expansion-panel-header translate
              >CustomizationSchemaGroupName{{
              group.name
              }}</mat-expansion-panel-header
              >
            }
            <ng-template matExpansionPanelContent>
              @for (property of group.variables; track track($index, property)) {
                <div
                  class="property"
                  >
                  <span translate>ThemeVarName{{ property }}</span>
                  <div class="container">
                    {{ me.value }}
                    <input
                      #me
              (colorPickerChange)="
                updateProperty('zalamo-editable-' + property, $event)
              "
                      [(colorPicker)]="varMap[property]"
                      [style.background]="me.value ? me.value : varMap[property]"
                      />
                    </div>
                  </div>
                }
              </ng-template>
            </mat-expansion-panel>
          }
        </mat-accordion>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      <lib-button (click)="save()">Zapisz</lib-button>
      <lib-button (click)="cancel()" bare>Anuluj</lib-button>
    </mat-dialog-actions>
